import React, { useEffect, useState } from 'react';
import { Button, Col, Row, Form } from "react-bootstrap";
import CustomSweetAlert from 'components/Shared/CustomSweetAlert';

const StepTwo = ({ handleNext, handleBack, storedData }) => {
    const apiURL = process.env.REACT_APP_JOB_URL;
    const [formData, setFormData] = useState({});
    const [errors, setErrors] = useState({});
    const [alert, setAlert] = useState([]);

    useEffect(() => {
        window.scrollTo(0, 0)
        if (storedData) {
            setFormData(prevState => ({
                ...prevState,
                consent: storedData?.confirmedEmploymentPolicy,
            }));
        }
    }, []);

    const validateForm = (formData) => {
        const { consent } = formData;
        const errors = {
            consent: consent === false && 'Consent is required',
        };
        return errors;
    }

    const handleSubmit = async () => {
        try {
            const errors = validateForm(formData);

            if (!Object.values(errors).some(Boolean)) {
                setErrors([]);
                setAlert(CustomSweetAlert({ type: "loading" }));
                const url = `/HRInduction/SubmitPrivacyConsent?inductionId=${storedData?.inductionId}&employeeId=${storedData?.employeeId}&pin=${storedData?.pin}`;
                const method = `post`;
                const response = await fetch(apiURL + url, {
                    method,
                    headers: [
                        ["Content-Type", "application/json"],
                        ["Content-Type", "text/plain"]
                    ],
                });
                if (response.status === 200) {
                    handleNext({ confirmedEmploymentPolicy: formData.shareCode });
                } else {
                    showErrorAlert(`Please fill out all required fields`);
                }
            } else {
                setErrors(errors);
                window.scrollTo(0, 0);
            }
        } catch (e) {
            showErrorAlert(`Something went wrong`);
        }
    }

    const handleCheckConsent = (e) => {
        setFormData({
            ...formData,
            consent: !formData?.consent
        })
    }

    const showErrorAlert = (message) => setAlert(CustomSweetAlert({
        type: "error", title: "Error", message: message,
        onConfirm: () => {
            hideAlert();
        }, showCancel: false
    }));

    const hideAlert = () => setAlert(null);

    return (
        <Row>
            <Col sm={12} md={12}>
                <h2 >2. Employeeprivacy policy</h2>
                <span style={{ marginTop: '-15px' }}><h2 >Data Consent Form</h2></span>
                <span style={{ marginTop: '-15px' }}>Please fill out all required fields</span>
            </Col>
            <Col sm={12} md={12}>
                <span><h5 className='text-center'><strong><u>INTRODUCTION</u></strong></h5></span>
                <span><h5 className='text-center'>FP McCann Limited takes your privacy very seriously and has put in place an employee privacy policy. The policy governs the use of your data and ensures that your personal data is managed with appropriate care, transparency and accountability in accordance with the General Data Protection Regulation (GDPR) May 2018.</h5></span>
            </Col>
            <Col sm={12} md={12}>
                <span><h5 className='text-center'><strong><u>WHAT IS FP MCCANN GOING TO DO IN RELATION TO GDPR?</u></strong></h5></span>
                <span>
                    <h5 className='text-center'>Fully comply with all obligations in the GDPR and ensure that our company privacy notices are written in a clear, plain way that people will understand.
                        The policy will be included in the Employee Handbook and has been distributed via noticeboards throughout the Company depots.
                    </h5>
                </span>
            </Col>
            <Col sm={12} md={12}>
                <span><h5 className='text-center'><strong><u>WHY WE HOLD DATA ON YOU:</u></strong></h5></span>
                <span><h5 className='text-center'>We hold your data for various reasons, but not limited to:</h5></span>
                <span><h5 className='text-center'><i className="fa fa-circle" style={{ fontSize: 5 }}></i>{' '}Payment of staff</h5></span>
                <span><h5 className='text-center'><i className="fa fa-circle" style={{ fontSize: 5 }}></i>{' '}Occupational health</h5></span>
                <span><h5 className='text-center'><i className="fa fa-circle" style={{ fontSize: 5 }}></i>{' '}Compliance with legal obligations</h5></span>
                <span><h5 className='text-center'><i className="fa fa-circle" style={{ fontSize: 5 }}></i>{' '}Administration of training/study/apprenticeships</h5></span>
            </Col>

            <Col sm={12} md={12}>
                <span><h5 className='text-center'><strong><u>INFORMATION WE MAY HOLD ON YOU:</u></strong></h5></span>
                <span><h5 className='text-center'>We may collect and hold, but not limited to:</h5></span>
                <span><h5 className='text-center'><i className="fa fa-circle" style={{ fontSize: 5 }}></i>{' '}Occupational health records</h5></span>
                <span><h5 className='text-center'><i className="fa fa-circle" style={{ fontSize: 5 }}></i>{' '}Photographs</h5></span>
                <span><h5 className='text-center'><i className="fa fa-circle" style={{ fontSize: 5 }}></i>{' '}Bank details</h5></span>
                <span><h5 className='text-center'><i className="fa fa-circle" style={{ fontSize: 5 }}></i>{' '}Attendance and conduct records</h5></span>
                <span><h5 className='text-center'><i className="fa fa-circle" style={{ fontSize: 5 }}></i>{' '}Compliance with legal obligations e.g. taxes, pensions, deductions</h5></span>
                <span><h5 className='text-center'>FP McCann undertakes not to retain personal data for longer than is necessary to ensure compliance with the legislation, and any other statutory requirements.</h5></span>
            </Col>

            <Col sm={12} md={12}>
                <span><h5 className='text-center'><strong><u>CONTACT US</u></strong></h5></span>
                <span><h5 className='text-center'>Please direct any queries about this Privacy Policy or about the way we process your personal information to our Data Protection Officer - dpo@fpmccann.co.uk</h5></span>
            </Col>

            <Col sm={12} md={12}>
                <span><h5 className='text-center'><strong><u>CONSENT</u></strong></h5></span>
                <Form.Group>
                    <Form.Check.Label>
                        <Form.Check.Input
                            type="checkbox"
                            checked={formData?.consent === true}
                            onChange={handleCheckConsent}
                        ></Form.Check.Input>
                        <span className="form-check-sign" style={{ paddingRight: "10px" }}></span>
                        <><span>I hereby give my consent for my personal information to be used by my employer, FP McCann Ltd, I understand that I can withdraw my consent at any time.</span><span className="star">*</span>
                        </>
                    </Form.Check.Label>
                </Form.Group>
                {errors.consent && <Form.Text className="text-danger"> <span className="star">*</span> {errors.consent} </Form.Text>}
            </Col>

            <Col sm={12} className="d-flex justify-content-between mt-3">
                <Button className="btn-lg btn-shadow btn-step" variamt="danger" onClick={handleBack} >Back</Button>
                <Button className="btn-lg btn-shadow btn-step" variant="success" onClick={handleSubmit} >Next Step</Button>
            </Col>
        </Row>


    );
};

export default StepTwo;